import { useEffect } from 'react';
import { INTERCOM_HORIZONTAL_PADDING, INTERCOM_VERTICAL_PADDING } from './intercomPadding';
import { useChatWidgetPositionStore } from './store';

/**
 * Avisa o Intercom (único widget de chat, PAI-140) quando a posição do store muda. Montar só no
 * layout: cada instância gera um `update` do Intercom por mudança de posição.
 */
const useChatWidgetPositionSync = () => {
  const isFooterVisible = useChatWidgetPositionStore((s) => s.isFooterVisible);
  const storePosition = useChatWidgetPositionStore((s) => s.position);

  // biome-ignore lint/correctness/useExhaustiveDependencies: posição e rodapé são o gatilho do update, não entram no payload
  useEffect(() => {
    window.Intercom?.('update', {
      horizontal_padding: INTERCOM_HORIZONTAL_PADDING,
      vertical_padding: INTERCOM_VERTICAL_PADDING,
    });
  }, [storePosition, isFooterVisible]);
};

export default useChatWidgetPositionSync;
